import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/testdata"

const serviceName = "TestData-Service: ";
export default class TestDataService {
  static generateCustomerTestData(customerId, processId, successF, errorF) {
    WrapperService.post(API_URL + "/" + customerId + "/" + processId, null, serviceName, successF, errorF);
  }
} 